/**
 * Trunnion AI - Dashboard View
 * Mission Control Dashboard with dense multi-row grid layout.
 */

import { FavoritesBar } from './FavoritesBar';
import { SystemHealthCard } from './SystemHealthCard';
import { SystemMetricsBar } from './SystemMetricsBar';
import { QuickActions } from './QuickActions';
import { LiveExecutionFeed } from './LiveExecutionFeed';
import { ApprovalQueueWidget } from './ApprovalQueueWidget';
import { TokenUsageChart } from './TokenUsageChart';
import { CostTrendChart } from './CostTrendChart';
import { AgentPerformanceGrid } from './AgentPerformanceGrid';
import { ClassificationBreakdownChart } from './ClassificationBreakdownChart';
import { ExecutionHeatmap } from './ExecutionHeatmap';
import { RecentAuditCard } from './RecentAuditCard';

export function DashboardView() {
  return (
    <div className="grid grid-cols-12 gap-4">
      {/* Row 0: Favorites Bar */}
      <div className="col-span-12">
        <FavoritesBar />
      </div>

      {/* Row 1: System Health + Metrics Bar */}
      <div className="col-span-12 lg:col-span-7">
        <SystemHealthCard />
      </div>
      <div className="col-span-12 lg:col-span-5">
        <SystemMetricsBar />
      </div>

      {/* Row 2: Quick Actions */}
      <div className="col-span-12">
        <QuickActions />
      </div>

      {/* Row 3: Live Feed + Approval Queue */}
      <div className="col-span-12 lg:col-span-7">
        <LiveExecutionFeed />
      </div>
      <div className="col-span-12 lg:col-span-5">
        <ApprovalQueueWidget />
      </div>

      {/* Row 4: Token Usage + Cost Trends */}
      <div className="col-span-12 lg:col-span-6">
        <TokenUsageChart />
      </div>
      <div className="col-span-12 lg:col-span-6">
        <CostTrendChart />
      </div>

      {/* Row 5: Agent Performance + Classification Breakdown */}
      <div className="col-span-12 lg:col-span-7">
        <AgentPerformanceGrid />
      </div>
      <div className="col-span-12 lg:col-span-5">
        <ClassificationBreakdownChart />
      </div>

      {/* Row 6: Execution Heatmap */}
      <div className="col-span-12">
        <ExecutionHeatmap />
      </div>

      {/* Row 7: Recent Audit */}
      <div className="col-span-12">
        <RecentAuditCard />
      </div>
    </div>
  );
}
